import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import './RefundTicketModal.css';

const RefundTicketModal = ({
  isOpen,
  toggle,
  ticketId,
  totalBill = 0,
  onRefund,
}) => {
  const [step, setStep] = useState(1);
  const [refundAmount, setRefundAmount] = useState(0);
  const [refundInputValue, setRefundInputValue] = useState('');
  const [selectedPercentage, setSelectedPercentage] = useState(null);
  const percentageOptions = [10, 20, 30, 40, 50, 75, 100];

  useEffect(() => {
    if (isOpen) {
      setStep(1);
      setRefundAmount(0);
      setRefundInputValue('');
      setSelectedPercentage(null);
    }
  }, [isOpen]);
  
  useEffect(() => {
    if (refundAmount > 0 && totalBill > 0) {
      const calculatedPercentage = (refundAmount / totalBill) * 100;
      
      const matchedPercentage = percentageOptions.find(percentage => 
        Math.abs(calculatedPercentage - percentage) < 0.01
      );
      
      setSelectedPercentage(matchedPercentage || null);
    } else {
      setSelectedPercentage(null);
    }
  }, [refundAmount, totalBill, percentageOptions]);

  const handlePercentageClick = (percentage) => {
    setSelectedPercentage(percentage);
    const amount = (percentage / 100) * totalBill;
    const formattedAmount = amount.toFixed(2);
    setRefundAmount(parseFloat(formattedAmount));
    setRefundInputValue(formattedAmount);
  };

  const handleRefundAmountChange = (e) => {
    const inputValue = e.target.value;
    
    if (inputValue === '' || /^(\d*\.?\d{0,2})$/.test(inputValue)) {
      setRefundInputValue(inputValue);
      
      const numValue = inputValue === '' ? 0 : parseFloat(inputValue);
      
      if (!isNaN(numValue)) {
        if (numValue > totalBill) {
          setRefundAmount(totalBill);
          setRefundInputValue(totalBill.toString());
        } else {
          setRefundAmount(numValue);
        }
      } else {
        setRefundAmount(0);
      }
    }
  };

  const handleRefund = () => {
    if (step === 1) {
      setStep(2);
    } else if (step === 2 && refundAmount > 0) {
      onRefund({
        ticketId,
        amount: refundAmount,
        percentage: selectedPercentage,
      });
      toggle();
    }
  };

  const handleClose = () => {
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className='refund-ticket-modal'
      centered
    >
      <ModalBody className='refund-ticket-modal-body'>
        <h2 className='refund-ticket-title'>Refund Ticket</h2>

        {step === 1 ? (
          <p className='refund-ticket-message'>Do you want to refund ticket?</p>
        ) : (
          <>
            <div className='refund-ticket-total-bill'>
              Total bill: ${totalBill.toFixed(2)}
            </div>

            <div className='refund-ticket-input-group'>
              <label className='refund-ticket-label'>Refund Amount</label>
              <div className='refund-ticket-input-container'>
                <span className='refund-ticket-currency-symbol'>$</span>
                <input
                  type='text'
                  value={refundInputValue}
                  onChange={handleRefundAmountChange}
                  placeholder='0.00'
                  className='refund-ticket-input'
                />
              </div>
            </div>

            <div className='refund-ticket-percentage-container'>
              {percentageOptions.map((percentage) => (
                <button
                  key={percentage}
                  onClick={() => handlePercentageClick(percentage)}
                  className={`refund-ticket-percentage-button ${
                    selectedPercentage === percentage ? 'selected' : ''
                  }`}
                >
                  {percentage}%
                </button>
              ))}
            </div>
          </>
        )}

        <div className='refund-ticket-actions'>
          <button
            className='refund-ticket-button refund-ticket-button-close'
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className={`refund-ticket-button refund-ticket-button-refund ${
              refundAmount <= 0 && step === 2 ? 'disabled' : ''
            }`}
            onClick={handleRefund}
            disabled={refundAmount <= 0 && step === 2}
          >
            {step === 1 ? 'Refund' : 'Confirm'}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default RefundTicketModal;